import { Box, Button } from "@mui/material";
import {
  nextIcon,
  prevIcon,
  prevIconDisabled,
  prevIconLight,
} from "assets/images";
import { useHistory, useLocation } from "react-router-dom";
import { SLPFormStep } from "utils/enums/slp-form";

type SLPFormButtonTypes = {
  activePartNumber: SLPFormStep;
  handleNext?: () => void;
};

const SLPFormButtons: React.FC<SLPFormButtonTypes> = ({
  activePartNumber,
  handleNext,
}) => {
  const history = useHistory();
  const location = useLocation<{
    slpId: number;
    studentId: number;
    partNumber: SLPFormStep;
  }>();

  const handleBack = () => {
    history.replace(location.pathname, {
      ...location.state,
      partNumber: activePartNumber - 1,
    });
  };

  return (
    <Box className="stepper-btn-group">
      <Button
        disabled={activePartNumber === SLPFormStep.HOPES_GOALS_AMBITIONS}
        onClick={handleBack}
        className="btn-prev"
        variant="outlined"
        key={`previous-${activePartNumber}`}
      >
        <img src={prevIcon} alt="Previous" className="active" />
        <img src={prevIconDisabled} alt="Previous" className="disabled" />
        <img src={prevIconLight} alt="Previous" className="hovered" />
        Previous
      </Button>

      {activePartNumber === SLPFormStep.PERSONAL_SMART_GOALS ? (
        <Button
          type="button"
          onClick={handleNext}
          className="btn-next"
          variant="contained"
        >
          Next
          <img src={nextIcon} alt="Next" />
        </Button>
      ) : (
        <Button type="submit" className="btn-next" variant="contained">
          {activePartNumber === SLPFormStep.WHERE_TO_FROM_HERE
            ? "Submit"
            : "Next"}
          <img src={nextIcon} alt="Next" />
        </Button>
      )}
    </Box>
  );
};

export default SLPFormButtons;
